/**
 * Top-level error boundary.
 *
 * A rendering bug in one screen should not leave a blank white page with no
 * way out — that is the worst possible failure mode for someone mid-task. This
 * shows what happened and offers a reload.
 */
import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // In a real deployment this is where an error reporter would be called.
    console.error('Unhandled UI error', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="auth-shell auth-shell-simple">
        <div className="auth-card">
          <div className="card">
            <div className="card-body stack">
              <h1 className="auth-title">Something went wrong</h1>
              <p className="muted">
                The page could not be displayed. Reloading usually fixes it; if it keeps happening, please report
                what you were doing.
              </p>

              {import.meta.env.DEV && (
                <pre
                  className="mono text-xs"
                  style={{
                    padding: 'var(--s-3)',
                    background: 'var(--c-surface-3)',
                    borderRadius: 'var(--r-md)',
                    overflow: 'auto',
                    maxHeight: 200,
                  }}
                >
                  {error.message}
                  {'\n'}
                  {error.stack}
                </pre>
              )}

              <div className="row">
                <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
                  Reload the page
                </button>
                <a href="/" className="btn">
                  Go to the dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
